import { Flex } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { HEIGHT as HEADER_HEIGHT } from "app/components/Header";
import { BodyM, HeaderS } from "ui/Typography/Typography";

export function NoBatteryInventory() {
  return (
    <Flex
      w="full"
      minH={`calc(100vh - ${HEADER_HEIGHT} - 2rem)`}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      textAlign="center"
      gap="s200"
      bgColor="white"
    >
      <HeaderS>
        <FormattedMessage id="pages.inventory.battery-management-page.placeholders.no-battery.title" />
      </HeaderS>
      <BodyM color="grey.800" maxW="293px">
        <FormattedMessage id="pages.inventory.battery-management-page.placeholders.no-battery.body" />
      </BodyM>
    </Flex>
  );
}
